import React, { useState, useCallback } from 'react';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Modal from 'buyside/components/presentation/Modal/modal';

import { newIdeaUrl } from 'buyside/util/urlHelper';

const NoJobAccessModal = ({ isAllocator, ...props }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const renderOpenModalButton = useCallback(
    () => <Button {...props} onClick={() => setIsModalOpen(true)} />,
    [props]
  );

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      renderOpenModalButton={renderOpenModalButton}
      title={isAllocator ? 'Contact Us' : 'Post Research to Continue'}
    >
      {(isAllocator && (
        <p>
          Thank you for your interest in this role. At this time we do not allow Allocators to apply
          to Buyside positions in the Job Vault. Please email{' '}
          <a href="mailto:jobs@sumzero.com">jobs@sumzero.com</a> with any questions.
        </p>
      )) || (
        <>
          <p>
            In order to apply to a job posting through SumZero you must have published at least one
            new Idea in the last three months. This Idea will be sent along with your application to
            the employer and allows candidates to differentiate themselves using their work product.
          </p>

          <p>
            If you are unable to do this or have additional questions, please email{' '}
            <a href="mailto:jobs@sumzero.com">jobs@sumzero.com</a>.
          </p>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            text="Submit Research"
            url={newIdeaUrl()}
            analyticsTag="submit-research"
          />
        </>
      )}
    </Modal>
  );
};

export default NoJobAccessModal;
